import {Component, Inject, Input, OnInit} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {LocalSettingsService} from 'src/app/services/local-settings.service';
import {SeoFooterComponent} from '../../layout/seo-footer/seo-footer.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {DOCUMENT, NgClass, NgStyle} from '@angular/common';
import {SeoHeaderComponent} from '../../layout/seo-header/seoHeader.component';
import {IconComponent} from '../icons-svgs/icons-svgs.component';
import {PlatformService} from '../../../services/platform-service.service';
import {ActivatedRoute, Router} from "@angular/router";
import {Meta, Title} from "@angular/platform-browser";


@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  standalone: true,
  imports: [SeoHeaderComponent, NgStyle, NgClass, MatExpansionModule, SeoFooterComponent, TranslateModule, IconComponent,]
})
export class HomePageComponent implements OnInit {
  carrouselImg =
  [{id: 0, name:'house',title: "LANDING_2.CARROUSELHOUSE", descri: "LANDING_2.CARROUSELHOUSEDESCRI" ,btn: "LANDING_2.CARROUSELHOUSEBTN" , Image:'/assets/img/showcase/Landing1/assets/salonSlide.webp', url: "accommodation/list"},
  {id: 1, name:'visa', title: "LANDING_2.CARROUSELVISA" , descri: "LANDING_2.CARROUSELVISADESCRI",btn: "LANDING_2.CARROUSELVISABTN" , Image:'/assets/img/HomePageOptimizedImg/obetenirVisa.png', url:"/livinfrance/login"},
  {id: 2, name:'attest',title:"LANDING_2.CARROUSELATTEST", descri: "LANDING_2.CARROUSELATTESTDESCRI" , btn: "LANDING_2.CARROUSELATTESTBTN", Image:'/assets/img/HomePageOptimizedImg/housingAttest.jpg', url:"housing-certificate/start"},
  {id: 3, name:'plane',title:"LANDING_2.CARROUSELPLANE", descri: "LANDING_2.CARROUSELPLANEDESCRI",btn:"LANDING_2.CARROUSELPLANEBTN" , Image:'/assets/img/HomePageOptimizedImg/assuVoyage.png', url:"/livinfrance/login"},
  ];

  currentCarrousel = this.carrouselImg[0];

  activeClass = 'house';
  isButtonClicked = false;
  urls = {
    register: '',
    faq1: 'livinfrance/login',
    faq2: 'livinfrance/login',
    faq3: 'livinfrance/login',
    faq4: 'livinfrance/login',
    faq5: 'livinfrance/login',
  }
  @Input() lang: string;

  constructor(
    private translate: TranslateService,
    private _localSettings: LocalSettingsService,
    private platformService : PlatformService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private pageTitle: Title,
    private meta: Meta,
    private route: ActivatedRoute,
  ) {
    let url = this.router.url;
    if(url.includes('accommodation') || url.includes('housing-certificate') || url.includes('school')){
      this.router.navigate(['en/' + url]);
    }
  }

  ngOnInit(): void {

    this.meta.addTag({ 
      rel: 'alternate', 
      hreflang: 'x-default', 
      href: 'https://livin-france.com/en' 
    });
    
    this.lang = this.route.snapshot.parent?.paramMap.get('lang');
    if(this.lang == 'en' || this.lang == 'fr'){
      this.setCurrentLang(this.lang);
    }
    // @ts-ignore
    if(this.lang != 'fr' && this.lang != 'en'){
      this.router.navigate([this.lang + '/login']);
    }
    if(!this.lang){
      this.lang = this._localSettings.getLanguage();
    }
    if(this.lang == 'fr'){
      this.pageTitle.setTitle("Livinfrance - Simplifiez votre déménagement en France");
      this.meta.updateTag({name: 'description', content: 'Votre plateforme unique pour les étudiants internationaux déménageant en France. Obtenez de l\'aide pour le visa, le logement, l\'assurance, et plus encore.'});
    }
    else{
      this.pageTitle.setTitle("Livinfrance - Simplify Your Move to France");
      this.meta.updateTag({name: 'description', content: 'Your one-stop platform for international students moving to France. Get help with visa, housing, insurance, and more.'});
    }

  }

  ngAfterViewInit()
  {
    if(this.platformService.isBrowserPlatform()){
      const lazyImages = this.document.querySelectorAll('.lazybg');
      lazyImages.forEach((image) => {
        image.classList.remove('lazybg');
      });
    }
  }

  setCarrousel(slide) {
    this.currentCarrousel = this.carrouselImg[slide];
  }
  setActiveClass(c) {
    this.isButtonClicked = true;
    this.activeClass = c;
    setTimeout(() => {
      this.isButtonClicked = false;
    }, 800)

  }

  getColorFromClass(activeClass) {
    switch (activeClass) {
      case 'house':
        return '#1C69FF';
      case 'visa':
        return '#FFCD1D';
      case 'student':
        return '#002FA7';
      case 'attest':
        return '#FF7B4C';
      case 'plane':
        return '#FFCD1D';
      case 'help':
        return '#1C69FF';
      case 'financial':
        return '#1C69FF';
        case 'financialS':
          return '#1C69FF';
      default:
        return 'transparent';
    }
  }

  setCurrentLang(lang){
    this.translate.use(lang);
    this.translate.currentLang = lang == 'en' ? 'en' : 'fr' ;
    this._localSettings.setLanguage(lang);
  }

  getFlag(type?) {
    let prefix = '';
    let suffix = '';
    if(type == 'url'){
      prefix = './assets/img/flags/4x3/';
      suffix = '.svg';
    }
    if (this.translate.currentLang == 'en') {
      return prefix + 'gb' + suffix;
    }
    return prefix + this.translate.currentLang + suffix;
  }

  goToLink(sublink, link){
    this.router.navigate([this.lang + '/' + sublink + link]);
  }

}
